import ReactDOM from "react-dom/client";
// The default generouted entry eagerly bundles every page into the first script.
// That file is about 9MB, and iPad Safari stops on it and leaves a blank page.
import { Routes } from "@generouted/react-router/lazy";
import { RaygunProvider } from "@/providers/RaygunProvider";
import Providers from "@/providers/providers";

import "./styles";
import { DevBanner } from "./components/Banner";
import { showDevBanner } from "./lib/urlUtils";
import { consumeBackendSourceQueryParam } from "@/lib/backendSource";

consumeBackendSourceQueryParam();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <RaygunProvider>
    <Providers>
      {showDevBanner && (
        <DevBanner
          description="Currently in Development"
          compactDescription="Development"
          variant="info"
          primaryAction={{
            label: "Switch to Production",
            compactLabel: "Switch",
            link: `https://m360.pgahq.com${window.location.pathname}`
          }}
        />
      )}
      <Routes />
    </Providers>
  </RaygunProvider>
);
